export default __webpack_public_path__ + "fonts/AI-icon.svg";